import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import DragDropContainer from './DragDropContainer';
import DraggableItem from './DraggableItem';

function generateDraggableItems(items, containerTag, customDragStyleClass) {
  return items.map(function (item, index) {
    return React.createElement(DraggableItem, {
      key: item.key,
      as: containerTag,
      index: index,
      dragStyleClass: customDragStyleClass
    }, item.render());
  });
}

export default function DragAndDrop(_ref) {
  var containerTag = _ref.containerTag,
      groupName = _ref.groupName,
      items = _ref.items,
      onFinishedDragging = _ref.onFinishedDragging,
      customDragStyleClass = _ref.customDragStyleClass;

  // track changes to item order using orderedItems
  var _React$useState = React.useState(items),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      orderedItems = _React$useState2[0],
      setOrderedItems = _React$useState2[1]; // generate draggable items using provided items using its' key and render function


  var _React$useState3 = React.useState(generateDraggableItems(items, containerTag, customDragStyleClass)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      draggableItems = _React$useState4[0],
      setDraggableItems = _React$useState4[1];

  var handleDragEnd = React.useCallback(function (result) {
    var destination = result.destination,
        source = result.source; // If dragged outside the drag-drop container or dragged to origin, just return

    if (!destination) {
      return;
    }

    var movedFromIndex = source.index;
    var movedToIndex = destination.index;
    var draggedToOrigin = destination.droppableId === source.droppableId && movedFromIndex === movedToIndex;

    if (draggedToOrigin) {
      return;
    } // Reorder items


    var reorderedItems = Array.from(orderedItems);
    reorderedItems.splice(movedFromIndex, 1);
    reorderedItems.splice(movedToIndex, 0, orderedItems[movedFromIndex]);
    setOrderedItems(reorderedItems); // invoke callback indicating changes in order of items

    onFinishedDragging(movedFromIndex, movedToIndex);
  }, [orderedItems, onFinishedDragging]); // When new items are provided, reset orderedItems

  React.useEffect(function () {
    setOrderedItems(items);
  }, [items]); // Each time orderedItems change, generate draggable items again to reflect ordering changes

  React.useEffect(function () {
    var reorderedItems = generateDraggableItems(orderedItems, containerTag, customDragStyleClass);
    setDraggableItems(reorderedItems);
  }, [orderedItems, containerTag, customDragStyleClass]);
  return React.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, React.createElement(DragDropContainer, {
    as: containerTag,
    groupName: groupName
  }, draggableItems));
}
DragAndDrop.propTypes = {
  /** indicates which html tag is used to generate the container */
  containerTag: PropTypes.string,

  /** unique group name to signify which items are allowed to move within same container  */
  groupName: PropTypes.string.isRequired,

  /** an array of items to render, each with a key and render function */
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    render: PropTypes.func.isRequired
  })),

  /** callback that should be invoked indicating changes in ordering of items */
  onFinishedDragging: PropTypes.func,

  /** css class to apply (should exclude sizing changes) while dragging an item */
  customDragStyleClass: PropTypes.shape({})
};
DragAndDrop.defaultProps = {
  containerTag: 'div',
  items: [],
  onFinishedDragging: function onFinishedDragging() {},
  customDragStyleClass: undefined
};